(function(){
  var GRID='#product-grid';
  var SIDEBARS=['.collection-filter-container', '.collection-filter-bck.colfil-mobile-only'];
  var busy=false;

  function withParams(url){
    try{
      var u=new URL(url, location.origin);
      var cur=new URLSearchParams(location.search);
      ['preview_theme_id','pb','_ab','_fd','_sc'].forEach(function(k){
        if(cur.has(k) && !u.searchParams.has(k)){ u.searchParams.set(k, cur.get(k)); }
      });
      return u.pathname + (u.search||'') + (u.hash||'');
    }catch(e){ return url; }
  }
  function fvc(sec){ return sec ? sec.querySelector('.fil-value-container') : null; }
  function lbl(w){ var t=w.querySelector('.colfilter-title'); return t?t.textContent.trim():''; }
  function openLabels(){
    var out=[];
    document.querySelectorAll('.colfilter-title-wrapper').forEach(function(w){
      var ul=fvc(w.closest('.filter-section'));
      if(ul && ul.classList.contains('active')){ out.push(lbl(w)); }
    });
    return out;
  }
  function applyOpen(labels){
    document.querySelectorAll('.colfilter-title-wrapper').forEach(function(w){
      var ul=fvc(w.closest('.filter-section')), i=w.querySelector('i'); var on=labels.indexOf(lbl(w))>-1;
      if(ul){ ul.classList.toggle('active', on); }
      if(i){ i.classList.toggle('bi-chevron-up', on); i.classList.toggle('bi-chevron-down', !on); }
    });
  }
  function toggle(w){
    var ul=fvc(w.closest('.filter-section')), i=w.querySelector('i'); if(!ul){ return; }
    var on=!ul.classList.contains('active');
    ul.classList.toggle('active', on);
    if(i){ i.classList.toggle('bi-chevron-up', on); i.classList.toggle('bi-chevron-down', !on); }
  }
  function drawer(open){
    document.querySelectorAll('.collection-filters').forEach(function(el){ el.classList.toggle('active', open); });
    document.querySelectorAll('.collection-filter-bck').forEach(function(el){ el.classList.toggle('active', open); });
  }

  function reinit(){
    try{
      document.querySelectorAll(GRID+' script').forEach(function(old){
        var s=document.createElement('script');
        if(old.src){ s.src=old.src; } else { s.textContent=old.textContent; }
        old.parentNode.replaceChild(s, old);
      });
    }catch(e){}
    try{ if(window.jdgm){ ['initJdgmBadges','customizeBadges','batchSpinner','renderBadges','loadBadges'].forEach(function(fn){ try{ if(typeof window.jdgm[fn]==='function'){ window.jdgm[fn](); } }catch(e){} }); } }catch(e){}
    try{
      var loader=document.querySelector('script[src*="judgeme"], script[src*="jdgm"], script[src*="judge.me"]');
      if(loader && loader.src){ var s=document.createElement('script'); s.src=loader.src; s.async=true; document.body.appendChild(s); }
    }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('shopify:section:load', {detail:{}})); }catch(e){}
    try{ window.dispatchEvent(new Event('scroll')); window.dispatchEvent(new Event('resize')); }catch(e){}
  }

  function navigate(url, push){
    if(busy){ return; } busy=true;
    var keepOpen=openLabels();
    var grid=document.querySelector(GRID);
    if(grid){ grid.style.transition='opacity .15s'; grid.style.opacity='0.4'; }
    fetch(withParams(url), {headers:{'X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin'}).then(function(r){
      if(!r.ok){ throw 0; } return r.text();
    }).then(function(html){
      var doc=new DOMParser().parseFromString(html, 'text/html');
      var ng=doc.querySelector(GRID), cg=document.querySelector(GRID);
      if(!ng || !cg){ throw 0; }
      cg.replaceWith(ng);
      SIDEBARS.forEach(function(sel){ var n=doc.querySelector(sel), c=document.querySelector(sel); if(n && c){ c.replaceWith(n); } });
      if(push){ try{ history.pushState({xxf:1}, '', withParams(url)); }catch(e){} }
      applyOpen(keepOpen);
      reinit();
      var g=document.querySelector(GRID); if(g){ g.style.opacity=''; }
      busy=false;
    }).catch(function(){ window.location=withParams(url); });
  }

  document.addEventListener('click', function(e){
    var title=e.target.closest('.colfilter-title-wrapper');
    if(title){ toggle(title); return; }
    var a=e.target.closest('.collection-filters a');
    if(a && a.getAttribute('href')){ e.preventDefault(); navigate(a.getAttribute('href'), true); return; }
    if(e.target.closest('.colfilter-btn')){ drawer(true); return; }
    if(e.target.closest('.colfil-close-btn')){ drawer(false); return; }
  });

  window.addEventListener('popstate', function(){ navigate(location.pathname + location.search, false); });
})();